import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import MainNavbar from "../components/MainNavbar";

function MainLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <MainNavbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default MainLayout;
